import {deleteDocument} from '../../api/documents'
import hydrateDocuments from './hydrateDocuments'
import getToken from '../account/getToken'

export default store => async ({fileId, skipFile}) => {
  const token = await getToken(store)()

  store.setState({
    isHydratingDocuments: true,
  })

  if (!token) return

  return deleteDocument({
    token,
    fileId,
    skipFile,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(response => {
      return hydrateDocuments(store)()
    })
    .catch(error => {
      store.setState({
        isHydratingDocuments: false,
      })
    })
}
